import React from "react";
import { CV } from "../components/cv";
import VladislavsGImg from "@/assets/images/vladislavs-g.png";

export default function CVVladislavsGaidass() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Vladislavs Gaidašs";
  }, []);

  return (
    <CV
      name="Vladislavs Gaidašs"
      photo={VladislavsGImg}
      title="Data & Data Platform Engineer"
      subtitle="Cloud-agnostic data platform engineering across GCP and Azure — pipelines, IaC, governance and analytics front-ends for retail, manufacturing and telecom."
      summary="Cloud-agnostic Data and Data Platform Engineer with almost 10 years of experience and certifications in both Google Cloud Platform and Microsoft Azure. Skilled in data engineering, analytics and data platform engineering, with work spanning data pipelines, infrastructure and front-end solutions (Power BI, Looker) in several data platforms within retail, manufacturing and telecommunications. Currently modernising a GCP-based data platform for a major Nordic retailer — moving resources under full IaC control, automating onboarding and IAM with Terraform and GitHub Actions, driving cost savings, and advising on data governance and protection."
      skills={{
        "Cloud – GCP": [
          "BigQuery",
          "Cloud Composer (Airflow)",
          "Dataflow",
          "Dataform",
          "Cloud Run",
          "Cloud Build",
          "Looker",
          "Knowledge Catalog",
        ],
        "Cloud – Azure": [
          "Data Factory",
          "Databricks / Delta Lake",
          "Data Lake",
          "SQL Database",
          "Analysis Services",
          "Logic Apps",
          "Automation",
        ],
        "Data Engineering": ["dbt", "SSIS", "Data modeling", "Data governance"],
        "Platform & DevOps": ["Terraform", "GitHub Actions", "CI/CD", "IaC"],
        "BI & Analytics": ["Power BI", "Looker", "Tableau", "DAX"],
        "Programming Languages": [
          "Python (incl. PySpark)",
          "SQL / T-SQL",
          "Java",
          "C#",
          "PowerShell",
        ],
        Languages: ["Latvian", "English", "Russian"],
      }}
      experience={[
        {
          role: "GCP Data / Data Platform Engineer",
          company: "Forefront Consulting, Malmö",
          period: "2021 – Present",
          description:
            "Member of the GCP division, working in the Data & Analytics and Application & Infrastructure Modernization teams.",
          highlights: [
            "Data Platform Engineer, major Nordic retailer: modernised a GCP data platform according to the Google Cloud Well-Architected Framework, migrating existing resources under full IaC control and supporting CI/CD, pipeline maintenance and data governance routines.",
            "Cut man-hours spent on onboarding and IAM by introducing configuration-based deployment and automation with Terraform and GitHub Actions.",
            "Drove cost savings — identified and removed shadow IT and orphaned resources and helped introduce cost-saving SaaS tooling; BigQuery monthly costs dropped by ca 30% during the PoC phase.",
            "Set up MCP connections together with the Head of Data and the AI Engineering team, exposing the data platform for AI assistant (Claude) usage across the organisation.",
            "Data Platform / Data Engineer, SaaS data platform: built the Cloud Foundation and inner platform layers in GCP and near-real-time ingestion pipelines for mobile services metrics served via APIs, plus automated deployment and release flows for pipelines, apps and IaC.",
            "Data Engineer, crowd insights platform: built and maintained Cloud Composer and BigQuery pipelines and external data delivery methods, simplified Tableau Server data flows, and introduced dbt Core as the team's transformation tool including its initial setup and DevOps.",
            "Mentor in internal Data & Analytics trainings.",
          ],
        },
        {
          role: "Azure SQL Developer / Data Engineer",
          company: "Tetra Pak, Lund",
          period: "2019 – 2021",
          description:
            "Member of the Cloud Analytics Platform team, and data engineer and data visualization developer in several teams within a SAFe program in predictive maintenance.",
          highlights: [
            "Implemented a support system for equipment data monitoring — back-end, reporting and parts of the DevOps pipelines.",
            "Built data pipelines ingesting data from various sources, including on-premises, and supported hosting of predictive models.",
            "Coordinated between teams in the SAFe program, providing technical assistance and supporting compliance with architectural guidelines.",
            "Azure (Data Factory, Databricks/Delta Lake, Data Lake, SQL Database, Analysis Services, Automation), Power BI, T-SQL, PySpark, PowerShell, C#.",
          ],
        },
        {
          role: "Microsoft Data & Analytics Senior Analyst",
          company: "Accenture, Riga",
          period: "2018 – 2019",
          description:
            "Data engineer and data visualization developer in a SAFe program within products & sales, part of the Microsoft Data & Analytics team.",
          highlights: [
            "Supported and improved an automated sales data ingestion and aggregation system.",
            "Implemented a sales promotion data aggregation and visualization system — source data analysis, data modeling, integration and storage layers, and reporting.",
            "Assisted the team on the Azure Data & Analytics stack and mentored interns and junior developers.",
            "Azure (Data Factory, Data Lake, SQL Database, Batch Account, Logic Apps), Power BI, MS SQL, SSIS, T-SQL, U-SQL, C#.",
          ],
        },
      ]}
      education={[
        {
          degree: "Bachelor of Engineering Sciences in Electronics",
          institution:
            "Transport and Telecommunication Institute, Riga — Telecommunication Systems and Computer Networks",
          year: "2011 – 2016",
        },
        {
          degree:
            "Bachelor of Engineering Sciences in Electronics (exchange studies)",
          institution: "Luleå University of Technology",
          year: "2013 – 2014",
        },
      ]}
      certifications={[
        {
          name: "Google Cloud Certified – Professional Cloud Architect",
          issuer: "Google Cloud",
          year: "2026 – 2028",
        },
        {
          name: "Google Cloud Certified – Professional Data Engineer",
          issuer: "Google Cloud",
          year: "2022 – 2028",
        },
        {
          name: "Google Cloud Certified – Professional Cloud Security Engineer",
          issuer: "Google Cloud",
          year: "2025 – 2027",
        },
        {
          name: "Microsoft Certified: Azure AI Engineer Associate",
          issuer: "Microsoft",
          year: "2023 – 2027",
        },
        {
          name: "Microsoft Certified: Fabric Analytics Engineer Associate",
          issuer: "Microsoft",
          year: "2024 – 2027",
        },
        {
          name: "Microsoft Certified: Fabric Data Engineer Associate",
          issuer: "Microsoft",
          year: "2025 – 2027",
        },
        {
          name: "Microsoft Certified: Azure Fundamentals",
          issuer: "Microsoft",
          year: "2019",
        },
      ]}
    />
  );
}
